export default class Loader {
    constructor($loader) {
        this.$loader = $loader;
        this.isLoading = false;

        this.loading = this.loading.bind(this);
    }

    /**
     * Loading
     * @param isLoading
     */
    loading(isLoading) {
        this.isLoading = isLoading;

        if (isLoading) {
            this.$loader.classList.add('loader--active');
        } else {
            this.$loader.classList.remove('loader--active');
        }
    }
}